<template>
    <keep-alive>
        <section class="addCustomer">
            <Nav title="创建客户" />
            <section class="form_area">
                <van-form @submit="onSubmit">
                    <div class="form_group">
                        <div class="header">
                            <h3>基本信息</h3>
                        </div>
                        <van-field
                            v-model="form.baseInfo.name"
                            name="name"
                            label="姓名"
                            placeholder="请填写客户姓名"
                            required
                            :rules="[{ required: true, message: '请填写客户姓名' }]"
                            maxlength="12"
                        />
                        <van-field 
                            name="gender" 
                            label="性别" 
                            :rules="[{ required: true, message: '请选择性别' }]"
                            required
                        >
                            <template #input>
                                <van-radio-group v-model="form.baseInfo.gender" direction="horizontal">
                                <van-radio name="1">男</van-radio>
                                <van-radio name="2">女</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>
                        <van-field
                            v-model="form.baseInfo.age"
                            name="age"
                            label="年龄"
                            type="number"
                            placeholder="请填写年龄"
                            :rules="[
                                { required: true, message: '请填写年龄' },
                                { pattern: /^(1[89]|[2-9]\d|100)$/, message:'年龄在18到100之间'}
                            ]"
                            required
                        />
                        <van-field
                            v-model="form.baseInfo.phoneNumber"
                            name="phoneNumber"
                            label="手机号"
                            placeholder="请填写手机号"
                            type = "tel"
                            :rules="[
                                { required: true, message: '请填写手机号' },
                                { pattern: /^1\d{10}$/, message:'请填写正确的手机号'}
                            ]"
                            required
                        />

                        <van-field
                            readonly
                            clickable
                            name="householdAddress"
                            :value="form.baseInfo.householdAddress"
                            label="户籍城市"
                            placeholder="请选择户籍城市"
                            @click="isHouseholdCityModel = true"
                            right-icon="arrow-down"
                        />
                        <van-popup v-model="isHouseholdCityModel" round position="bottom" class="model_class" >
                            <van-area title="请选择" :area-list="areaList" columns-num="2" @cancel="isHouseholdCityModel=false" @confirm="confirmHouseholdCity" />
                        </van-popup>
                        
                        <van-field
                            readonly
                            clickable
                            name="channelName"
                            :value="form.baseInfo.channelName"
                            label="来源渠道"
                            placeholder="请选择来源渠道"
                            @click="showChannelPicker = true"
                            :rules="[{ required: true, message: '请选择来源渠道' }]"
                            required
                        >
                            <template #button>
                                <van-button size="mini" plain hairline native-type="button" type="primary" @click.stop="onChannelManageClick">渠道管理</van-button>
                            </template>
                        </van-field>
                        <van-popup v-model="showChannelPicker" position="bottom">
                            <van-picker
                                show-toolbar
                                :columns="channelList"
                                @confirm="channelPickConfirm"
                                @cancel="showChannelPicker = false"
                            />
                        </van-popup>
                    </div>

                    <div class="form_group">
                        <div class="header">
                            <h3>贷款信息</h3>
                        </div>
                        <van-field
                            readonly
                            clickable
                            name="applicationTime"
                            :value="form.loanInfo.applicationTime"
                            label="申请时间"
                            placeholder="请选择申请时间"
                            @click="showApplicationTimePicker = true"
                            :rules="[
                                { required: true, message: '请选择申请时间' },
                            ]"
                            required
                        />
                        <van-popup v-model="showApplicationTimePicker" position="bottom">
                            <van-datetime-picker
                                v-model="form.loanInfo.applicationTimeGMT"
                                type="datetime"
                                title="申请时间"
                                @confirm="applicationTimePcikerConfirm"
                                @cancel="showApplicationTimePicker = false"
                            />
                        </van-popup>

                        <van-field
                            v-model="form.loanInfo.loanAmountYuan"
                            name="loanAmountYuan"
                            label="贷款金额"
                            placeholder="请填写贷款金额"
                            type = "digit"
                            :rules="[
                                { required: true, message: '请填写贷款金额' },
                            ]"
                            required
                        >
                            <template #extra>
                                元
                            </template>
                        </van-field>
                        <van-field
                            v-model="form.loanInfo.loanTerm"
                            name="loanTerm"
                            label="贷款期限"
                            placeholder="请填写贷款期限"
                            type = "digit"
                            :rules="[
                                { required: true, message: '请填写贷款期限' },
                            ]"
                            required
                        >
                            <template #extra>
                                月
                            </template>
                        </van-field>

                        <van-field 
                            name="loanPurpose" 
                            label="贷款目的" 
                            :rules="[{ required: true, message: '请选择贷款目的' }]"
                            required
                        >
                            <template #input>
                                <van-radio-group v-model="form.loanInfo.loanPurpose" direction="horizontal">
                                <van-radio name="1">综合消费</van-radio>
                                <van-radio name="2">生产经营</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>

                        <van-field
                            readonly
                            clickable
                            name="productType"
                            :value="form.loanInfo.productTypeName"
                            label="产品类型"
                            placeholder="请选择产品类型"
                            @click="showProductTypePicker = true"
                            right-icon="arrow-down"
                            :rules="[
                                { required: true, message: '请选择产品类型' },
                            ]"
                            required

                        />
                        <van-popup v-model="showProductTypePicker" position="bottom">
                            <van-picker
                                show-toolbar
                                :columns="productTypeList"
                                @confirm="productTypePickConfirm"
                                @cancel="showProductTypePicker = false"
                            />
                        </van-popup>
                    </div>

                    <div class="form_group">
                        <div class="header">
                            <h3>工作信息</h3>
                        </div>
                        <van-field
                            readonly
                            clickable
                            name="workAddress"
                            :value="form.workInfo.workAddress"
                            label="工作城市"
                            placeholder="请选择工作城市"
                            @click="isWorkCityModel = true"
                            right-icon="arrow-down"
                            :rules="[
                                { required: true, message: '请选择工作城市' },
                            ]"
                            required
                        />
                        <van-popup v-model="isWorkCityModel" round position="bottom" class="model_class" >
                            <van-area title="请选择" :area-list="areaList" columns-num="2" @cancel="isWorkCityModel=false" @confirm="confirmWorkCity" />
                        </van-popup>

                        <van-field
                            readonly
                            clickable
                            name="occupation"
                            :value="form.workInfo.occupationName"
                            label="职业"
                            placeholder="请选择客户职业"
                            @click="showOccupationPicker = true"
                            right-icon="arrow-down"
                            required
                            :rules="[{ required: true, message: '请选择客户职业' }]"
                        />
                        <van-popup v-model="showOccupationPicker" position="bottom">
                            <van-picker
                                show-toolbar
                                :columns="occupationList"
                                @confirm="occupationPickerConfirm"
                                @cancel="showOccupationPicker = false"
                                :default-index="0"
                            />
                        </van-popup>

                        <van-field
                            v-model="form.workInfo.monthlyIncomeYuan"
                            name="monthlyIncomeYuan"
                            label="月收入"
                            placeholder="请填写月收入"
                            type = "digit"
                        >
                            <template #extra>
                                元
                            </template>
                        </van-field>

                        <van-field
                            readonly
                            clickable
                            name="incomeForm"
                            :value="form.workInfo.incomeFormName"
                            label="收入形式"
                            placeholder="请选择收入形式"
                            @click="showIncomeFormPicker = true"
                            right-icon="arrow-down"
                        />
                        <van-popup v-model="showIncomeFormPicker" position="bottom">
                            <van-picker
                                show-toolbar
                                :columns="incomeFormList"
                                @confirm="incomeFormPickConfirm"
                                @cancel="showIncomeFormPicker = false"
                                :default-index="0"
                            />
                        </van-popup>

                        <van-field 
                            name="socialSecurityStatus" 
                            label="社保状态" 
                        >
                            <template #input>
                                <van-radio-group v-model="form.workInfo.socialSecurityStatus" direction="horizontal">
                                <van-radio name="1">有</van-radio>
                                <van-radio name="0">无</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>

                        <van-field 
                            name="socialSecurityDetails" 
                            label="社保详情"
                            v-if="form.workInfo.socialSecurityStatus == 1"
                        >
                            <template #input>
                                <van-radio-group v-model="form.workInfo.socialSecurityDetails" direction="horizontal">
                                <van-radio name="1">连续缴纳6个月以下</van-radio>
                                <van-radio name="2">连续缴纳6个月以上</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>

                        <van-field 
                            name="accumulationFundStatus" 
                            label="公积金状态" 
                        >
                            <template #input>
                                <van-radio-group v-model="form.workInfo.accumulationFundStatus" direction="horizontal">
                                <van-radio name="1">有</van-radio>
                                <van-radio name="0">无</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>

                        <van-field 
                            name="accumulationFundDetails" 
                            label="公积金详情"
                            v-if="form.workInfo.accumulationFundStatus == 1"
                        >
                            <template #input>
                                <van-radio-group v-model="form.workInfo.accumulationFundDetails" direction="horizontal">
                                <van-radio name="1">连续缴纳6个月以下</van-radio>
                                <van-radio name="2">连续缴纳6个月以上</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>

                        <van-field 
                            name="commercialInsurance"
                            label="商业保单" 
                        >
                            <template #input>
                                <van-radio-group v-model="form.workInfo.commercialInsurance" direction="horizontal">
                                <van-radio name="1">有</van-radio>
                                <van-radio name="0">无</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>

                    </div>

                    <div class="form_group">
                        <div class="header">
                            <h3>车产信息</h3>
                        </div>
                        <van-field 
                            name="vehicleOwnership" 
                            label="是否有车" 
                        >
                            <template #input>
                                <van-radio-group v-model="form.carInfo.vehicleOwnership" direction="horizontal">
                                <van-radio name="1">有</van-radio>
                                <van-radio name="0">无</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>

                        <van-field 
                            name="vehiclePurchaseMethod	" 
                            label="购买方式"
                            v-if="form.carInfo.vehicleOwnership == 1"
                        >
                            <template #input>
                                <van-radio-group v-model="form.carInfo.vehiclePurchaseMethod" direction="horizontal">
                                <van-radio name="1">全款</van-radio>
                                <van-radio name="2">分期</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>

                        <van-field
                            name="vehicleUse" 
                            label="使用性质"
                            v-if="form.carInfo.vehicleOwnership == 1" 
                        >
                            <template #input>
                                <van-radio-group v-model="form.carInfo.vehicleUse" direction="horizontal">
                                <van-radio name="1">非营运</van-radio>
                                <van-radio name="2">营运</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>

                        <van-field
                            v-model="form.carInfo.licensePlate"
                            name="licensePlate"
                            label="车牌号"
                            placeholder="请填写车牌号"
                            type = "text"
                            v-if="form.carInfo.vehicleOwnership == 1"
                        />

                        <van-field
                            v-model="form.carInfo.mileage"
                            name="mileage"
                            label="公里数"
                            placeholder="请填写公里数"
                            type = "digit"
                            v-if="form.carInfo.vehicleOwnership == 1"
                        >
                            <template #extra>
                                公里
                            </template>
                        </van-field>

                        <van-field
                            v-model="form.carInfo.vehicleValuationYuan"
                            name="vehicleValuationYuan"
                            label="车辆估值"
                            placeholder="请填写车辆估值"
                            type = "digit"
                            v-if="form.carInfo.vehicleOwnership == 1"
                        >
                            <template #extra>
                                元
                            </template>
                        </van-field>


                        <van-field 
                            name="vehicleStatus"
                            label="当前状态"
                            v-if="form.carInfo.vehicleOwnership == 1" 
                        >
                            <template #input>
                                <van-radio-group v-model="form.carInfo.vehicleStatus" direction="horizontal">
                                <van-radio name="1">未抵押</van-radio>
                                <van-radio name="2">已抵押</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>

                    </div>

                    <div class="form_group">
                        <div class="header">
                            <h3>房产信息</h3>
                        </div>
                        <van-field 
                            name="realEstateOwnership" 
                            label="是否有房" 
                        >
                            <template #input>
                                <van-radio-group v-model="form.houseInfo.realEstateOwnership" direction="horizontal">
                                <van-radio name="1">有</van-radio>
                                <van-radio name="0">无</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>

                        <van-field 
                            name="realEstatePurchaseMethod	" 
                            label="购买方式"
                            v-if="form.houseInfo.realEstateOwnership == 1"
                        >
                            <template #input>
                                <van-radio-group v-model="form.houseInfo.realEstatePurchaseMethod" direction="horizontal">
                                <van-radio name="1">全款</van-radio>
                                <van-radio name="2">按揭</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>

                        <van-field
                            name="realEstateNature" 
                            label="房产性质"
                            v-if="form.houseInfo.realEstateOwnership == 1" 
                        >
                            <template #input>
                                <van-radio-group v-model="form.houseInfo.realEstateNature" direction="horizontal">
                                <van-radio name="1">商品房</van-radio>
                                <van-radio name="2">自建房</van-radio>
                                <van-radio name="3">厂房</van-radio>
                                <van-radio name="4">其他</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>

                        <van-field
                            v-model="form.houseInfo.buildingArea"
                            name="buildingArea"
                            label="建筑面积"
                            placeholder="请填写建筑面积"
                            type = "number"
                            v-if="form.houseInfo.realEstateOwnership == 1"
                        >
                            <template #extra>
                                平米
                            </template>
                        </van-field>

                        <van-field
                            v-model="form.houseInfo.realEstateValuationYuan"
                            name="realEstateValuationYuan"
                            label="房产估值"
                            placeholder="请填写房产估值"
                            type = "digit"
                            v-if="form.houseInfo.realEstateOwnership == 1"
                        >
                            <template #extra>
                                元
                            </template>
                        </van-field>


                        <van-field 
                            name="realEstateStatus"
                            label="当前状态"
                            v-if="form.houseInfo.realEstateOwnership == 1" 
                        >
                            <template #input>
                                <van-radio-group v-model="form.houseInfo.realEstateStatus" direction="horizontal">
                                <van-radio name="1">未抵押</van-radio>
                                <van-radio name="2">已抵押</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>

                    </div>

                    <div class="form_group">
                        <div class="header">
                            <h3>信用负债</h3>
                        </div>
                        <van-field 
                            name="huabei" 
                            label="支付宝花呗" 
                        >
                            <template #input>
                                <van-radio-group v-model="form.assetInfo.huabei" direction="horizontal">
                                <van-radio name="1">有</van-radio>
                                <van-radio name="0">无</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>

                        <van-field 
                            name="baitiao" 
                            label="京东白条"
                        >
                            <template #input>
                                <van-radio-group v-model="form.assetInfo.baitiao" direction="horizontal">
                                <van-radio name="1">有</van-radio>
                                <van-radio name="0">无</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>

                        <van-field 
                            name="creditCardStatus" 
                            label="信用卡"
                        >
                            <template #input>
                                <van-radio-group v-model="form.assetInfo.creditCardStatus" direction="horizontal">
                                    <van-radio name="1">有</van-radio>
                                    <van-radio name="0">无</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>

                        <van-field
                            name="sesameScore" 
                            label="芝麻分"
                        >
                            <template #input>
                                <van-radio-group v-model="form.assetInfo.sesameScore" direction="horizontal">
                                    <van-radio name="1">600分以下</van-radio>
                                    <van-radio name="2">600~650分</van-radio>
                                    <van-radio name="3">650~700分</van-radio>
                                    <van-radio name="4">700分以上</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>

                        <van-field
                            name="creditOverdue" 
                            label="征信逾期" 
                        >
                            <template #input>
                                <van-radio-group v-model="form.assetInfo.creditOverdue" direction="horizontal">
                                    <van-radio name="1">无逾期记录</van-radio>
                                    <van-radio name="2">有逾期记录已结清</van-radio>
                                    <van-radio name="3">有逾期未结清</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>

                        <van-field
                            v-model="form.assetInfo.totalDebtYuan"
                            name="totalDebtYuan"
                            label="当前总负债"
                            placeholder="请填写当前总负债"
                            type = "digit"
                        >
                            <template #extra>
                                元
                            </template>
                        </van-field>
                    </div>

                    <div class="btn_wrap">
                        <van-button round block type="primary" native-type="submit">提交</van-button>
                    </div>
                </van-form>
            </section>
        </section>
    </keep-alive>
</template>

<script>
import Nav from "components/Nav";
import { Toast, Dialog } from 'vant';
import {areaList}  from '@vant/area-data';

import customerServer from "api/customer";
import settingServer from "api/setting";

export default {
    name: "addCustomer",
	components: {
		Nav,
	},
    data() {
        return {
            form: {
                baseInfo: {
                    gender: '1',
                },

                loanInfo: {
                    applicationTimeGMT: new Date(),
                    loanPurpose: '1',
                },

                workInfo: {

                },

                carInfo: {

                },

                houseInfo: {

                },

                assetInfo: {

                },

                sourceType: 1 //接口bug
                // sourceType: 4, //机构端人工录入
            },

            formCopy: {},
            
            channelList: [],
            showChannelPicker: false,

            showApplicationTimePicker: false,

            showProductTypePicker: false,
            productTypeList: [
                {text:'信用贷'},
                {text:'车抵贷'},
                {text:'房抵贷'},
                {text:'保单贷'},
                {text:'企业贷'}
            ],

            showOccupationPicker: false,
            occupationList: [
                {text:'上班族'},
                {text:'个体户'},
                {text:'企业主'},
                {text:'自由职业'},
                {text:'公务员'}
            ],

            showIncomeFormPicker: false,
            incomeFormList: [
                {text:'银行代发'},
                {text:'现金'},
                {text:'自存'},
            ],
            

            isHouseholdCityModel: false,
            isWorkCityModel: false,
            areaList,

            accountType: '',
            account: '',

            savedScrollPosition: {},
		};
    },
    created() {
        console.log("Component created");
        this.formCopy = JSON.parse(JSON.stringify(this.form));
        this.accountType = localStorage.getItem('accountType')
        this.account = localStorage.getItem('account')

        this.getInfo()
	},
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			})
		}
	},

    activated() {
        console.log("Component activated");
        console.log(this.savedScrollPosition.y)

        // 如果账号发生变化，则重新初始化表单，重置页面滚动条位置
        if (this.account != localStorage.getItem('account')) {
            this.account = localStorage.getItem('account')
            this.form = JSON.parse(JSON.stringify(this.formCopy))

            this.savedScrollPosition = {}
        }

        this.accountType = localStorage.getItem('accountType')
        this.getChannelInfo()

        if(this.savedScrollPosition) {
            window.scrollTo(
                this.savedScrollPosition.x, 
                this.savedScrollPosition.y
            )
        }
    },
    deactivated() {
        console.log("Component deactivated");
    },

    beforeRouteLeave(to, from, next) {
        console.log("before addCusomter Router Leave")

        const scrollPosition = {
            x: window.scrollX,
            y: window.scrollY 
        }
        this.savedScrollPosition = scrollPosition
        console.log(this.savedScrollPosition.y)

        next(() => {
        })
    },
    
    methods: {
        getInfo() {
            this.getChannelInfo()
        },

        getChannelInfo() {
            settingServer.getChannelPageList({ pageNum:1, pageSize:1000 }).then((res) => {
                if (res.data.total) {
                    this.channelList = []
                    res.data.list.forEach(channel => {
                        this.channelList.push({"text": channel.channelName, "channelId": channel.id});
                    });

                    console.log(this.channelList)
                } else {
                    this.channelList = []
                }
            })
        },

        productTypePickConfirm(item, index) {
            this.form.loanInfo.productTypeName = item.text
            this.form.loanInfo.productType = index+1
            console.log(this.form)
            this.showProductTypePicker = false
        },
        
		confirmHouseholdCity(e) {
			this.form.baseInfo.householdAddress = e[0].name + '-' + e[1].name

            this.form.baseInfo.householdProvince = e[0].name
            this.form.baseInfo.householdCity = e[1].name

			this.isHouseholdCityModel = false
		},

        confirmWorkCity(e) {
			this.form.workInfo.workAddress = e[0].name + '-' + e[1].name

            this.form.workInfo.workProvince = e[0].name
            this.form.workInfo.workCity = e[1].name

			this.isWorkCityModel = false
		},

        channelPickConfirm(item, index) {
            this.form.baseInfo.channelName = item.text
            this.form.baseInfo.channelId = item.channelId
            console.log(this.form)
            this.showChannelPicker = false
        },

        applicationTimePcikerConfirm(value) {
            this.form.loanInfo.applicationTime = this.formatDate(value)
            console.log(this.form)
            this.showApplicationTimePicker = false
        },

        formatDate(date) {
            const addZero = (n) => (n < 10 ? '0' : '') + n;
            const yyyy = date.getFullYear();
            const mm = addZero(date.getMonth() + 1);
            const dd = addZero(date.getDate());
            const HH = addZero(date.getHours());
            const MM = addZero(date.getMinutes());
            const SS = addZero(date.getSeconds());

            return `${yyyy}-${mm}-${dd} ${HH}:${MM}:${SS}`;
        },

        occupationPickerConfirm(value, index) {
            this.form.workInfo.occupationName = value.text
            this.form.workInfo.occupation = index + 1
            console.log(this.form)

            this.showOccupationPicker = false
        },

        incomeFormPickConfirm(value, index) {
            this.form.workInfo.incomeFormName = value.text
            this.form.workInfo.incomeForm = index + 1
            console.log(this.form)

            this.showIncomeFormPicker = false
        },

        onSubmit() {
            if (this.form.loanInfo.loanAmountYuan * 100) this.form.loanInfo.loanAmount = this.form.loanInfo.loanAmountYuan * 100
            if (this.form.workInfo.monthlyIncomeYuan) this.form.workInfo.monthlyIncome = this.form.workInfo.monthlyIncomeYuan * 100
            if (this.form.carInfo.vehicleValuationYuan) this.form.carInfo.vehicleValuation = this.form.carInfo.vehicleValuationYuan * 100
            if (this.form.houseInfo.realEstateValuationYuan) this.form.houseInfo.realEstateValuation = this.form.houseInfo.realEstateValuationYuan * 100
            if (this.form.assetInfo.totalDebtYuan) this.form.assetInfo.totalDebt = this.form.assetInfo.totalDebtYuan * 100

            console.log(this.form)
            console.log(this.formCopy)

            customerServer.addCustomer(this.form).then((res) => {
                Dialog.confirm({
                    title: '创建成功',
                    message: '创建客户成功，可继续创建或者返回',
                    confirmButtonText: '继续创建',
                    cancelButtonText: '返回',
                })
                .then(() => {
                // on confirm
                    this.form = JSON.parse(JSON.stringify(this.formCopy))
                })
                .catch(() => {
                // on cancel
                    this.$router.go(-1)
                });
            })
        },

        onChannelManageClick() {
            if (this.accountType != 0) return Toast('无操作权限，请联系机构管理员')

            this.$router.push({ name: "channel-list" });
        },

    },
};    
</script>

<style lang="scss">
	.addCustomer {
		padding-top: 46px;
		padding-bottom: 100px;

        .form_area {
            .form_group {
                background-color: #FDFDFD;
                border-radius: 24px;
                margin-bottom: 22px;

                .header {
                    padding: 20px 30px 16px 30px;
                    border-bottom: 1px solid #E9F0F8;

                    h3 {
                        color: #303030;
                        font-size: 17px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 22px;
                    }
                }

                .van-cell {
                    background-color: #FDFDFD;
                    padding: 10px 30px;
                }



                .van-cell:first-child {
                    border-radius: 24px 24px 0 0;
                }

                .van-cell:last-child, .van-cell.last {
                    border-radius: 0 0 24px 24px;
                }

                .van-cell--required::before {
                    left: 22px;
                    top: 12px;
                }
            }

            .btn_wrap {
                position: fixed;
                bottom: 30px;
                width: 100%;
                padding: 0 16px;
            }
        }

        .van-stepper__input {
            width: 48px;
        }

        .tips_area {
            border-radius: 24px;
            background: #FDFDFD;
            padding: 0 0 18px 16px;

            h3 {
                color: #4D5B80;
                font-size: 14px;
                line-height: 22px;
                font-weight: 400;
                font-style: normal;
                padding: 15px 0;
                border-bottom: 1px dotted #E9F0F8;
            }

            ol {
                margin-top: 10px;
                margin-left: 20px;
                margin-right: 30px;
                list-style-type: decimal;

                li {
                    color: #4D5B80;
                    font-size: 13px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 22px;
                    margin-bottom: 4px;
                }
            }
        }

        .van-button--mini.van-button--plain {
            background-color: #fff;
            color: #055CE8;
            font-size: 10px;

            .van-button__content::before {
                content: '' !important;
                display: none;
            }

        }

        .van-radio--horizontal{
            margin-bottom: 12px;
        }
	}
</style>


// WEBPACK FOOTER //
// src/views/customer/Add.vue